import * as z from "zod";

export const disconnectOmsTiktokIntegration = {
  name: "disconnectOmsTiktokIntegration" as const,
  input: z.object({}),
  output: z.object({ success: z.boolean() }),
};
